import {
  CONVERSION_AND_ROI_PREFIX,
  PROJECTS_REPORT_PREFIX,
  REPORTS_URL,
  USAGE_REPORT_PREFIX,
} from '@app/app-routing-paths';
import { FeatureAccessConfig } from '@app/shared/config/feature-access.config';

export interface ReportPage {
  url: string;
  access: FeatureAccessConfig;
  label: string;
}

export const REPORT_PAGES: ReportPage[] = [
  {
    url: `${REPORTS_URL}/${CONVERSION_AND_ROI_PREFIX}`,
    access: FeatureAccessConfig.CONVERSION_AND_ROI_REPORT,
    label: 'NAVIGATION_BAR.CONVERSION_AND_ROI_REPORT',
  },
  {
    url: `${REPORTS_URL}/${USAGE_REPORT_PREFIX}`,
    access: FeatureAccessConfig.USAGE_REPORT,
    label: 'NAVIGATION_BAR.USAGE_REPORT',
  },
  {
    url: `${REPORTS_URL}/${PROJECTS_REPORT_PREFIX}`,
    access: FeatureAccessConfig.PROJECTS_REPORT,
    label: 'NAVIGATION_BAR.PROJECTS_REPORT',
  },
];
